import LogInfoSchema from '../schemas/LogInfoSchema'

export default function LogInfoVo(initData = {}) {
  return LogInfoSchema.validateSync(initData)
}
